import { ShowerHead, Bath, Building2, Hammer, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "../Reveal";

const services = [
  {
    icon: ShowerHead,
    title: "Inloopdouches",
    desc: "Strakke walk-ins met glas, regendouches en luxueuze afwerking. Volledig op maat ontworpen voor uw ruimte.",
    img: "/brand/services-v2/inloopdouches.png",
    href: "/inloopdouche-plaatsen",
  },
  {
    icon: Bath,
    title: "Complete badkamers",
    desc: "Van ontwerp tot oplevering. Tegelwerk, sanitair, verlichting en verwarming — wij regelen alles, één aanspreekpunt.",
    img: "/brand/services-v2/complete-badkamer-v4.png",
    href: "/badkamer-renoveren",
  },
  {
    icon: Building2,
    title: "Toiletten zakelijk",
    desc: "Renovatie van toiletruimtes in bedrijfspanden, horeca en kantoren. Representatief, duurzaam en snel uitgevoerd.",
    img: "/brand/services-v2/toiletten-zakelijk-v6.png",
    href: "/zakelijke-toiletrenovatie",
  },
  {
    icon: Hammer,
    title: "Maatwerk renovatie",
    desc: "Heeft u specifieke wensen? Wij ontwerpen en realiseren uw ideeën — natuursteen, indelingswijzigingen, verlichtingsplannen.",
    img: "/brand/services-v2/maatwerk-v2.png",
    href: "/toilet-renoveren",
  },
];

export default function Services() {
  return (
    <section
      id="diensten"
      data-testid="services-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <span className="tag-overline">01 — Diensten</span>
            <h2 className="mt-4 text-5xl md:text-6xl text-[#0A0A0A] leading-[1.02] uppercase tracking-tight">
              Vakmanschap voor
              <br />
              <span className="text-[#1E5BC6]">elk type ruimte.</span>
            </h2>
            <p className="mt-6 text-lg text-[#5A5A5A] max-w-2xl">
              Van een compact gastentoilet tot een complete master suite —
              MasterBathrooms levert volledige renovaties, ontworpen rondom uw
              wensen.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 80}>
              <article
                data-testid={`service-card-${i}`}
                className="group bg-white border border-[#E5E7EB] hover:-translate-y-1 hover:shadow-xl hover:border-[#1E5BC6]/30 transition-all duration-500 h-full flex flex-col"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover img-zoom"
                  />
                </div>
                <div className="p-7 md:p-9 flex-1 flex flex-col">
                  <div className="w-12 h-12 bg-[#E9F0FB] flex items-center justify-center text-[#1E5BC6]">
                    <s.icon size={22} strokeWidth={1.8} />
                  </div>
                  <h3 className="mt-5 text-2xl md:text-3xl text-[#0A0A0A] uppercase tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[#5A5A5A] leading-relaxed">{s.desc}</p>
                  <Link
                    to={s.href}
                    data-testid={`service-more-${s.href}`}
                    className="mt-5 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-bold text-[#1E5BC6] hover:gap-3 transition-all"
                  >
                    Meer info <ArrowRight size={14} />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
